
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-organization",
      function () {
        return require("private-next-pages/new-organization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-organization"])
      });
    }
  